import { memo } from "react";
import { Colors } from "../../utils/colors";
import { HorizontalDivider } from "../Dividers/HorizontalDivider";
import { VerticalDivider } from "../Dividers/VerticalDivider";

type LandingPageDividedSectionProps = {
  isDesktopSize: boolean;
  leftSection: {
    header: string;
    subtext: string;
    image: string;
    imageWidth?: number;
  };
  rightSection: {
    header: string;
    subtext: string;
    image: string;
    imageWidth?: number;
  };
  verticalDividerHeight: number;
};

// Used within LandingPage screens when displaying two sections side by side with a divider in between
const LandingPageDividedSection = (props: LandingPageDividedSectionProps) => {
  const { isDesktopSize, leftSection, rightSection, verticalDividerHeight } =
    props;

  const styles = {
    subHeaderText: {
      fontSize: 32,
      fontWeight: 500,
      color: Colors.WHITE,
      whiteSpace: "pre-line",
    },
    headerSubtext: {
      fontSize: 18,
      fontWeight: 500,
      color: Colors.GRAY1,
      letterSpacing: "-0.5px",
    },
    largeImage: {
      width: "100%",
      height: "auto",
    },
    sectionContainer: {
      maxWidth: 516,
      gap: isDesktopSize ? 60 : 40,
      flex: 1,
      minWidth: 0,
    },
  };

  return (
    <div className="ColumnNormal" style={{ maxWidth: 1152 }}>
      <HorizontalDivider
        altWidth={0.5}
        altColor={Colors.BLACK1}
        containerStyles={{ maxWidth: 1152 }}
      />
      <div
        className={isDesktopSize ? "RowNormal" : "ColumnNormal"}
        style={{ gap: isDesktopSize ? 67 : 40 }}
      >
        <div
          className="ColumnNormal"
          style={{
            ...styles.sectionContainer,
            paddingTop: isDesktopSize ? 60 : 40,
          }}
        >
          <div
            className="ColumnNormal"
            style={{ gap: 20, maxWidth: isDesktopSize ? 411 : "auto" }}
          >
            <h2 style={styles.subHeaderText}>{leftSection.header}</h2>
            <p style={styles.headerSubtext}>{leftSection.subtext}</p>
          </div>
          <img
            src={leftSection.image}
            alt={leftSection.header}
            className="slide-up"
            style={{
              ...styles.largeImage,
              objectFit: "contain",
              width: leftSection.imageWidth,
            }}
          />
        </div>
        {isDesktopSize ? (
          <VerticalDivider
            height={verticalDividerHeight}
            color={Colors.BLACK1}
            thickness={0.5}
          />
        ) : (
          <HorizontalDivider
            altWidth={0.5}
            altColor={Colors.BLACK1}
            containerStyles={{ maxWidth: 1152 }}
          />
        )}
        <div
          className="ColumnNormal"
          style={{
            ...styles.sectionContainer,
            paddingTop: isDesktopSize ? 60 : 0,
          }}
        >
          <div
            className="ColumnNormal"
            style={{ gap: 20, maxWidth: isDesktopSize ? 411 : "auto" }}
          >
            <h2 style={styles.subHeaderText}>{rightSection.header}</h2>
            <p style={styles.headerSubtext}>{rightSection.subtext}</p>
          </div>
          <img
            src={rightSection.image}
            alt={rightSection.header}
            className="slide-up"
            style={{
              ...styles.largeImage,
              objectFit: "contain",
              width: rightSection.imageWidth,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(LandingPageDividedSection);
